import {Alert, Breadcrumb, Button} from "antd";
import {Link} from "react-router-dom";
import {DashboardWrapper} from "../../../layouts/dashboard-wrapper";
import {StyledPageWrapper} from "../../../styles/dashboard/calls/calls";
import {LiveClassesTemplateWidget} from "../../../components/live-classes/template-widget/template-widget";
import {ErrorBoundary} from "react-error-boundary";
import {CreateLiveEventMultiStepFormWrapper} from "../../../liveEvents/useCases/create-live-event/multi-step/multi-step-form-wrapper";
import {StyledHideStepsOnMobile} from "../../../components/offering-form/general/steps/styles";
import {CreateLiveEventSteps} from "../../../liveEvents/useCases/create-live-event/multi-step/create-live-event-steps";
import {CreateLiveEventContextWrapper} from "../../../liveEvents/useCases/create-live-event/context/create-live-event/context-wrapper";

function LiveClassCreatePage() {
  return (
    <DashboardWrapper pageTitle="Create new live event">
      <CreateLiveEventContextWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/live-classes">Live events</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Create new live event</Breadcrumb.Item>
        </Breadcrumb>
        <StyledPageWrapper>
          <div className="main-area">
            <ErrorBoundary
              FallbackComponent={({error, resetErrorBoundary}) => (
                <div style={{marginTop: "1.8rem"}}>
                  <Alert
                    message="Sorry, something went wrong."
                    showIcon
                    description={error.message}
                    type="error"
                    action={
                      <Button
                        onClick={() => {
                          resetErrorBoundary();
                        }}
                        size="small"
                        danger
                      >
                        Reset
                      </Button>
                    }
                  />
                </div>
              )}
            >
              <CreateLiveEventMultiStepFormWrapper />
            </ErrorBoundary>
          </div>
          <div className="widget-area">
            <StyledHideStepsOnMobile>
              <CreateLiveEventSteps />
            </StyledHideStepsOnMobile>
            <LiveClassesTemplateWidget />
          </div>
        </StyledPageWrapper>
      </CreateLiveEventContextWrapper>
    </DashboardWrapper>
  );
}

export {LiveClassCreatePage};
